import React from "react";
import { Link } from "react-router-dom";
import "../../styles/components/notifications.css";

const getNotificationIconClassName = (icon, tone) => {
  const resolvedIcon = icon || "fa-bell";
  const baseIconClass = resolvedIcon.startsWith("fa-")
    ? `fa ${resolvedIcon}`
    : resolvedIcon;

  return `${baseIconClass} text-${tone || "info"}`;
};

const NotificationDropdown = ({
  isOpen,
  notifications = [],
  unreadCount = 0,
  onToggle,
  onClose,
  onNotificationClick,
  onMarkAllRead,
}) => (
  <li className={isOpen ? "show dropdown" : "dropdown"}>
    <a
      href="#!"
      className="dropdown-toggle icon-menu marketplace-notification-trigger"
      data-toggle="dropdown"
      onClick={(event) => {
        event.preventDefault();
        onToggle();
      }}
    >
      <i className="icon-bell"></i>
      {unreadCount > 0 ? <span className="notification-dot"></span> : null}
    </a>
    <ul className={isOpen ? "dropdown-menu notifications show" : "dropdown-menu notifications"}>
      <li className="header marketplace-notification-header d-flex justify-content-between align-items-center">
        <strong>
          {unreadCount > 0
            ? `${unreadCount} notific${unreadCount === 1 ? "a nuova" : "he nuove"}`
            : "Nessuna nuova notifica"}
        </strong>
        {notifications.length > 0 ? (
          <a
            href="#!"
            title="Segna tutte come lette"
            aria-label="Segna tutte le notifiche come lette"
            onClick={(event) => {
              event.preventDefault();
              if (onMarkAllRead) {
                onMarkAllRead();
              }
            }}
          >
            <i className="fa fa-check"></i>
          </a>
        ) : null}
      </li>

      {notifications.length > 0 ? (
        <li className="marketplace-notifications-list">
          <ul>
            {notifications.map((notification) => (
              <li key={notification.id} className={notification.read ? "" : "marketplace-notification-item--unread"}>
                <Link
                  to={notification.link || "#"}
                  onClick={() => {
                    if (onNotificationClick) {
                      onNotificationClick(notification);
                    }
                    onClose();
                  }}
                >
                  <div className="media marketplace-notification-item">
                    <div className="media-left">
                      <i
                        className={getNotificationIconClassName(
                          notification.icon,
                          notification.tone
                        )}
                      ></i>
                    </div>
                    <div className="media-body">
                      <div className="text">
                        <strong>{notification.title}</strong>
                        <span>{notification.message}</span>
                      </div>
                      <span className="timestamp">{notification.timestampLabel}</span>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </li>
      ) : (
        <li className="marketplace-notification-empty">
          <div className="media marketplace-notification-item">
            <div className="media-left">
              <i className={getNotificationIconClassName("fa-bell", "info")}></i>
            </div>
            <div className="media-body">
              <div className="text">
                <strong>Tutto sotto controllo</strong>
                <span>Qui compariranno nuovi aggiornamenti su ordini, offerte e pagamenti.</span>
              </div>
            </div>
          </div>
        </li>
      )}

    </ul>
  </li>
);

export default NotificationDropdown;

